import { render, staticRenderFns } from "./TableHeaderContainer.vue?vue&type=template&id=f810913a&scoped=true"
import script from "./TableHeaderContainer.vue?vue&type=script&lang=js"
export * from "./TableHeaderContainer.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderContainer.vue?vue&type=style&index=0&id=f810913a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f810913a",
  null
  
)

export default component.exports